export default __webpack_public_path__ + "static/media/misc-books5-1920w.e5954e58.avif";